import type { AccordionPanel } from '@modules/search/components/filter-drawer/FilterAccordion';

export const DEFAULT_ACTIVE_PANELS = 3;

/**
 * Get the default keys of panels to show as open.
 * Not intended for mobile.
 * For more info see: https://archipro.atlassian.net/browse/GROW-3675
 *
 * @param panels
 *      - Panel array to extract keys from
 * @param activePanelsShown
 *      - The amount of panels you want to show
 *      - Default to 3 as per the ticket requirements
 * @returns
 *      - An array of keys for the given panels
 */

export const getInitialActivePanelsKeys = (
    panels: AccordionPanel[],
    activePanelsShown: number = DEFAULT_ACTIVE_PANELS
) => {
    return panels.slice(0, activePanelsShown).map((panel) => panel.title.key);
};
